import { z } from 'zod';

// Shared CRM company enums, factored into their own module so both
// `companies.schemas.ts` and `company-contact-links.schemas.ts` can import them
// without a circular dependency (companies → company-contact-links → here).
//
// Domain enum tokens are UPPER_CASE per the AGENTS.md union-type convention.
// The German labels users see live in the frontend; the category names have no
// clean English equivalent, so they carry the propertyagent spelling upper-cased.

export const CRM_COMPANY_TYPES = [
  'PROJEKTENTWICKLER',
  'IMMOBILIENMAKLER',
  'HAUSVERWALTUNG',
  'IMMOBILIENGUTACHTER',
  'NOTARIAT',
  'BANK',
  'VERSICHERUNG',
  'HANDWERKER',
  'ARCHITEKT',
  'SONSTIGE',
] as const;
export const CrmCompanyTypeSchema = z.enum(CRM_COMPANY_TYPES);
export type CrmCompanyType = z.infer<typeof CrmCompanyTypeSchema>;

// Lifecycle state. Only ACTIVE is set in IMM-4.1; the ARCHIVED transition and
// soft-delete land in IMM-4.2.
export const CRM_COMPANY_STATUSES = ['ACTIVE', 'ARCHIVED'] as const;
export const CrmCompanyStatusSchema = z.enum(CRM_COMPANY_STATUSES);
export type CrmCompanyStatus = z.infer<typeof CrmCompanyStatusSchema>;
